export default "__VITE_ASSET__BnrUZ6XS__"